import { render, staticRenderFns } from "./BaseColorPicker.vue?vue&type=template&id=3cde6ad4&"
import script from "./BaseColorPicker.vue?vue&type=script&lang=js&"
export * from "./BaseColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports